module.exports = __webpack_public_path__ + "static/panier-f3d4fbed2ceb274d4910e2ac050e85b4.jpg";